import { Action } from 'redux';

export const SHOW_PASSWORD_RESET_TEMPLATE_MODAL_YN = 'adminstration-template/SHOW_PASSWORD_RESET_TEMPLATE_MODAL_YN';
export const HIDE_PASSWORD_RESET_TEMPLATE_MODAL_YN = 'adminstration-template/HIDE_PASSWORD_RESET_TEMPLATE_MODAL_YN';
export const CREATE_PASSWORD_RESET_EMAIL_TEMPLATE = 'adminstration-template/CREATE_PASSWORD_RESET_EMAIL_TEMPLATE';
export const SHOW_EMAIL_VARIFICATION_MODAL_YN = 'adminstration-template/SHOW_EMAIL_VARIFICATION_MODAL_YN';
export const HIDE_EMAIL_VARIFICATION_MODAL_YN = 'adminstration-template/HIDE_EMAIL_VARIFICATION_MODAL_YN';
export const SHOW_EMAIL_VARIFICATION_OPTION_MODAL_YN = 'adminstration-template/SHOW_EMAIL_VARIFICATION_OPTION_MODAL_YN';
export const HIDE_EMAIL_VARIFICATION_OPTION_MODAL_YN = 'adminstration-template/HIDE_EMAIL_VARIFICATION_OPTION_MODAL_YN';
export const CREATE_EMAIL_VARIFICATION_TEMPLATE = 'adminstration-template/CREATE_EMAIL_VARIFICATION_TEMPLATE';
export const SHOW_DELETE_CONFIRMATION_MODAL = 'adminstration-template/SHOW_DELETE_CONFIRMATION_MODAL';
export const HIDE_DELETE_CONFIRMATION_MODAL = 'adminstration-template/HIDE_DELETE_CONFIRMATION_MODAL';
export const GET_VERIFY_EMAIL = 'adminstration-template/GET_VERIFY_EMAIL_TEMPLATE';
export const GET_VERIFY_EMAIL_COMPLETE = 'adminstration-template/GET_VERIFY_EMAIL_COMPLETE';
export const UPDATE_VERIFY_EMAIL = 'adminstration-template/UPDATE_VERIFY_EMAIL';
export const GET_PASSWORD_RESET_TEMPLATE = 'adminstration-template/GET_PASSWORD_RESET_TEMPLATE';
export const GET_PASSWORD_RESET_TEMPLATE_COMPLETE = 'adminstration-template/GET_PASSWORD_RESET_TEMPLATE_COMPLETE';

export const getPasswordResetTemplate = () => {
  return {
    type: GET_PASSWORD_RESET_TEMPLATE,
  };
};

export const getPasswordResetTemplateComplete = (data: any) => {
  return {
    type: GET_PASSWORD_RESET_TEMPLATE_COMPLETE,
    payload: data,
  };
};

export const showPasswordResetEmailTemplateModalYN = () => {
  return {
    type: SHOW_PASSWORD_RESET_TEMPLATE_MODAL_YN,
  };
};

export const hidePasswordResetEmailTemplateModalYN = () => {
  return {
    type: HIDE_PASSWORD_RESET_TEMPLATE_MODAL_YN,
  };
};
export const createPasswordResetEmailTemplate = (data: any) => {
  return {
    type: CREATE_PASSWORD_RESET_EMAIL_TEMPLATE,
    payload: data,
  };
};

export const showEmailVarificationModal = () => {
  return {
    type: SHOW_EMAIL_VARIFICATION_MODAL_YN,
  };
};
export const hideEmailVarificationModal = () => {
  return {
    type: HIDE_EMAIL_VARIFICATION_MODAL_YN,
  };
};
export const showEmailVarificationOptionModal = () => {
  return {
    type: SHOW_EMAIL_VARIFICATION_OPTION_MODAL_YN,
  };
};
export const hideEmailVarificationOptionModal = () => {
  return {
    type: HIDE_EMAIL_VARIFICATION_OPTION_MODAL_YN,
  };
};

export const createEmailVarificationTemplate = (data: any) => {
  return {
    type: CREATE_EMAIL_VARIFICATION_TEMPLATE,
    payload: data,
  };
};
export const showDeleteConfirmationModal = () => {
  return {
    type: SHOW_DELETE_CONFIRMATION_MODAL,
  };
};
export const hideDeleteConfirmationModal = () => {
  return {
    type: HIDE_DELETE_CONFIRMATION_MODAL,
  };
};

export const getVerifyEmailComplete = (data: any) => {
  return {
    type: GET_VERIFY_EMAIL_COMPLETE,
    payload: data,
  };
};
export const updateVerifyEmail = (data: any) => {
  return {
    type: UPDATE_VERIFY_EMAIL,
    payload: data,
  };
};
export const DELETE_VERIFY_EMAIL = 'adminstration-template/DELETE_VERIFY_EMAIL';
export const deleteVerifyEmail = (data: any) => {
  return {
    type: DELETE_VERIFY_EMAIL,
    payload: data,
  };
};
export const UPDATE_PASSWORD_RESET_EMAIL = 'adminstration-template/UPDATE_PASSWORD_RESET_EMAIL';
export const updatePasswordResetEmail = (data: any) => {
  return {
    type: UPDATE_PASSWORD_RESET_EMAIL,
    payload: data,
  };
};

export const getVerifyEmail = () => {
  return {
    type: GET_VERIFY_EMAIL,
  };
};

export const DELETE_PASSWORD_RESET_EMAIL = 'adminstration-template/DELETE_PASSWORD_RESET_EMAIL';
export const deletePasswordResetEmail = (data: any) => {
  return {
    type: DELETE_PASSWORD_RESET_EMAIL,
    payload: data,
  };
};

export interface ShowPasswordResetEmailTemplate extends Action<typeof SHOW_PASSWORD_RESET_TEMPLATE_MODAL_YN> {}
export interface HidePasswordResetEmailTemplate extends Action<typeof HIDE_PASSWORD_RESET_TEMPLATE_MODAL_YN> {}
export interface ShowEmailVarificationModalAction extends Action<typeof SHOW_EMAIL_VARIFICATION_MODAL_YN> {}
export interface HideEmailVarificationModalAction extends Action<typeof HIDE_EMAIL_VARIFICATION_MODAL_YN> {}
export interface ShowEmailVarificationOptionModalAction extends Action<
  typeof SHOW_EMAIL_VARIFICATION_OPTION_MODAL_YN
> {}
export interface HideEmailVarificationOptionModalAction extends Action<
  typeof HIDE_EMAIL_VARIFICATION_OPTION_MODAL_YN
> {}
export interface ShowDeleteConfirmationModalAction extends Action<typeof SHOW_DELETE_CONFIRMATION_MODAL> {}
export interface HideDeleteConfirmationModalAction extends Action<typeof HIDE_DELETE_CONFIRMATION_MODAL> {}
export interface GetVerifyEmailCompleteAction extends Action<typeof GET_VERIFY_EMAIL_COMPLETE> {
  readonly payload: any;
}
export interface GetPasswordResetTemplateCompleteAction extends Action<typeof GET_PASSWORD_RESET_TEMPLATE_COMPLETE> {
  readonly payload: any;
}

export type AdministrationTemplateAction =
  | ShowPasswordResetEmailTemplate
  | HidePasswordResetEmailTemplate
  | ShowEmailVarificationModalAction
  | HideEmailVarificationModalAction
  | ShowEmailVarificationOptionModalAction
  | HideEmailVarificationOptionModalAction
  | ShowDeleteConfirmationModalAction
  | HideDeleteConfirmationModalAction
  | GetVerifyEmailCompleteAction
  | GetPasswordResetTemplateCompleteAction;
